<script setup lang="ts">
const sceneUrl = 'https://prod.spline.design/k-xYdIMLBOGBJGqh/scene.splinecode'
const {
  public: { splineViewerScriptUrl: viewerModuleUrl },
} = useRuntimeConfig()

const shouldRender = ref(false)
const isViewerReady = ref(false)

let desktopQuery: MediaQueryList | null = null

async function loadViewer() {
  if (isViewerReady.value) {
    return
  }

  if (!customElements.get('spline-viewer')) {
    await import(/* @vite-ignore */ viewerModuleUrl)
  }

  isViewerReady.value = true
}

function handleDesktopChange(event: MediaQueryListEvent) {
  shouldRender.value = event.matches

  if (event.matches) {
    void loadViewer()
  }
}

onMounted(() => {
  desktopQuery = window.matchMedia('(min-width: 1024px)')
  shouldRender.value = desktopQuery.matches

  if (desktopQuery.matches) {
    void loadViewer()
  }

  desktopQuery.addEventListener('change', handleDesktopChange)
})

onBeforeUnmount(() => {
  desktopQuery?.removeEventListener('change', handleDesktopChange)
})
</script>

<template>
  <div
    v-if="shouldRender"
    class="absolute left-0 w-500 hidden h-full transform -translate-x-1/2 lg:right-0 lg:flex lg:w-auto lg:translate-0 z-2"
  >
    <spline-viewer
      v-if="isViewerReady"
      :url="sceneUrl"
      class="block h-full w-full"
    />
  </div>
</template>
